import React from 'react';
import CarView from './CarView';
import InsuranceView from './InsuranceView';
import { PROCEDURE_TYPE, REGISTRY_TYPE } from '../../../../configs';
import { formatRegistryNumber } from '../../../../utils/formatters';

export default function ApplicationVehicleView({ currentApplication = {}, data, fieldsValidation }) {
  const {
    insurance, procedure,
    registry_subjects = [],
    registry_subject_id,
    registry_subject,
    registryType = REGISTRY_TYPE.VEHICLE,
    numbers,
  } = currentApplication;

  const params = {};
  if (registry_subject_id) {
    params.registry_id = registry_subject_id;
  } else {
    params.numbers = [currentApplication.number];
  }

  return (
    <>
      { ![PROCEDURE_TYPE.PROCEDURE_1227_6].includes(procedure)
        ? (
          <>
            <div className="f4">Номер записи в реестре ЛТ</div>
            {formatRegistryNumber(numbers, registry_subjects, registry_subject, registryType, fieldsValidation, 'vehicle')}
            <div className="mb-3" />
          </>
        ) : null}

      {![PROCEDURE_TYPE.PROCEDURE_1227_6, PROCEDURE_TYPE.PROCEDURE_1227_7, PROCEDURE_TYPE.PROCEDURE_kt_exlt, PROCEDURE_TYPE.PROCEDURE_1227_8, PROCEDURE_TYPE.PROCEDURE_1227_9].includes(procedure) ? (
        <>
          <div className="f4">Информация по ОСАГО владельца ТС</div>
          <InsuranceView data={insurance} hideSeries formMeta={fieldsValidation} prefix="application_vehicle." />
          <div className="mb-3" />
        </>
      ) : null}
      {![PROCEDURE_TYPE.PROCEDURE_1227_8, PROCEDURE_TYPE.PROCEDURE_1227_7, PROCEDURE_TYPE.PROCEDURE_1227_9].includes(procedure) ? (
        <>
          <div className="f4">Информация о транспортном средстве</div>
          <CarView data={data} procedure={procedure} fieldsValidation={fieldsValidation} currentApplication={currentApplication} prefix="application_vehicle." />
          <div className="mb-3" />
        </>
      ) : null}
    </>
  );
}
